module.exports = __webpack_public_path__ + "images/services/bitbucket-mark-contained-gradient-blue.4f7358360c7752f80847.svg";